import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import BadgesUsadas from './BadgesUsadas';
import SelectCrear from './SelectCrear';
import SelectFiltrado from './SelectFiltrado';
import FormInput from './FormInput';
import BtnGuardarEdit from './BtnGuardarEdit';

function OfertaDemanda(props) {

    const [valueOferta, setValueOferta] = useState(-1);
    const [valueDemanda, setValueDemanda] = useState(-1);
    const [rubroEliminado, setRubroEliminado] = useState();
    const [demandaEliminada, setDemandaEliminada] = useState();
    const [ofertaEliminada, setOfertaEliminada] = useState();
    const [reloadCount, setReloadCount] = useState(0);

    useEffect(() => {
        if (props.filtro == true)
            document.getElementById("ofertaDemandaFiltro").classList.remove("d-none");
    }, [props.filtro]);

    function agregarRubro(badge) {
        props.setBadgesRubro([...props.badgesRubro, badge]);
    }

    function eliminarRubro(option) {
        setRubroEliminado(option);
        props.setBadgesRubro(props.badgesRubro.filter(item => item.value !== option.value));
    }

    function agregarOferta(oferta) {
        if (oferta !== null && oferta != undefined && oferta.label) {

            if (oferta.value < 0) {
                const capitalize = (str) =>
                    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

                const separadores = /[,\/\-]| y /i;

                let nuevasOfertas = [];

                if (separadores.test(oferta.label)) {
                    const partes = oferta.label
                        .split(separadores)
                        .map((o) => o.trim())
                        .filter((o) => o.length > 0);
                    if (partes.length > 0) {
                        nuevasOfertas = partes.map((parte, index) => ({
                            value: oferta.value - index,
                            label: capitalize(parte),
                        }));
                        setValueOferta(valueOferta - partes.length);
                    }
                } else if (oferta.label.trim().length > 0) {
                    nuevasOfertas = [{ value: oferta.value, label: capitalize(oferta.label) }];
                    setValueOferta(valueOferta - 1);
                }

                props.setBadgesOferta([...props.badgesOferta, ...nuevasOfertas]);

                if (document.getElementById('nuevaOferta').value)
                    document.getElementById('nuevaOferta').value = '';
            } else {
                props.setBadgesOferta([...props.badgesOferta, oferta]);

            }
        }
    }
    
    function eliminarOferta(option) {
        setOfertaEliminada(option);
        props.setBadgesOferta(props.badgesOferta.filter(item => item.value !== option.value));
    }


    function agregarDemanda(demanda) {
        if (demanda !== null && demanda !== undefined && demanda.label) {

            if (demanda.value < 0) {
                const capitalize = (str) =>
                    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

                const separadores = /[,\/\-]| y /i;

                let nuevasDemandas = [];

                if (separadores.test(demanda.label)) {
                    const partes = demanda.label
                        .split(separadores)
                        .map((o) => o.trim())
                        .filter((o) => o.length > 0);

                    if (partes.length > 0) {
                        nuevasDemandas = partes.map((parte, index) => ({
                            value: demanda.value - index,
                            label: capitalize(parte),
                        }));
                        setValueDemanda(valueDemanda + partes.length);
                    }
                } else if (demanda.label.trim().length > 0) {
                    nuevasDemandas = [{ value: demanda.value, label: capitalize(demanda.label) }];
                    setValueDemanda(valueDemanda + 1);
                }

                props.setBadgesDemanda([...props.badgesDemanda, ...nuevasDemandas]);

                if (document.getElementById('nuevaDemanda').value)
                    document.getElementById('nuevaDemanda').value = '';
            } else {
                props.setBadgesDemanda([...props.badgesDemanda, demanda]);
            }
        }
    }

    function eliminarDemanda(option) {
        //setBadgesDemanda(badgesDemanda => badgesDemanda.filter(item => item.value !== value));
        setDemandaEliminada(option);
        props.setBadgesDemanda(props.badgesDemanda.filter(item => item.value !== option.value));
    }
    useEffect(() => {
        if (props.badgesRubro.length === 0 && props.badgesDemanda.length === 0 && props.badgesOferta.length === 0)
            setReloadCount(prev => prev + 1)
    }, [props.badgesOferta, props.badgesDemanda, props.badgesRubro]);
    return (
        <>
            <div id={props.filtro ? "ofertaDemandaFiltro" : "ofertaDemanda"} className='d-none'>
                <div className={props.filtro ? 'row' : 'row mb-5'}>
                    <div className={props.filtro ? 'mb-2' : 'col-md-3 offset-sm-1 col-sm-10 col-lg-2'}>
                        <label class="form-label letraDatos mb-2">
                            {props.filtro ? "Rubros que desee" : 'Seleccione a que rubro/s pertenece su empresa'}
                        </label>

                    </div>
                    <div className={props.filtro ? 'col' : 'col-lg-8 col-md-7 col-sm-10 offset-sm-1 offset-md-0'}>
                        <SelectFiltrado agregarRubro={agregarRubro} option={rubroEliminado} url={"empresa/getAllRubros"} placeholder={"Rubro"} reload={reloadCount} />
                        <BadgesUsadas badges={props.badgesRubro} funcion={eliminarRubro} />
                    </div>

                </div>
                <div className={props.filtro ? 'row mt-4' : 'row mb-5'}>

                    <div className={props.filtro ? 'mb-2' : ' col-md-3 offset-sm-1 col-sm-10 col-lg-2'}>
                        <label for="exampleInputEmail1" class="form-label letraDatos mb-2">

                            {props.filtro ? "Productos que usted desee" : <div className='fw-bold'>Oferta (Productos y/o servicios que fabrique o distribuya su empresa)</div>}
                        </label>

                    </div>


                    <div className={props.filtro ? 'col' : 'col-lg-8 col-md-7 col-sm-10 offset-sm-1 offset-md-0'}>
                        {/*<div class="input-group mb-3 mt-1">
                            <input type="text" id="ofertaText" class="form-control letraDatos" placeholder="Producto/Servicio" 
                            aria-label="Producto/Servicio" aria-describedby="button-addon2"/>
                            <button class="btn btn-outline-primary btnProductos" type="button" id="button-addon2" onClick={agregarOferta}>Agregar</button>
                        </div>*/}

                        <div class="mb-3 mt-1">
                            {props.filtro ?
                                <SelectFiltrado agregarRubro={agregarOferta} option={ofertaEliminada} url={"empresa/distintosProductosOfrecidos"} placeholder={"Producto/Servicio"} reload={reloadCount} />
                                :

                                <>
                                    <label class="form-label letraDatos">Seleccione sus servicios o productos</label>
                                    {/* <SelectCrear //selectedOption={selectedOferta} setSelectedOption = {setSelectedOferta}                        
                                value={valueOferta} setValue={setValueOferta} agregarBadge={agregarOferta} optionEliminada={ofertaEliminada}/>*/}
                                    <div class={"form-text textoErrores ms-1 d-inline"}>(Opcional)</div>

                                    <SelectFiltrado agregarRubro={agregarOferta} option={ofertaEliminada} url={"empresa/todosLosProductos"} placeholder={"Producto/Servicio"} />

                                    <FormInput id={"nuevaOferta"} text={"Registre nuevos servicios o productos"} type={"text"} className={"col-12"} helper={"(Opcional)"} placeholder={'Ej.: Café, Panadería, Diseño gráfico, Consultoría'} />
                                    <div className='text-center'>
                                        <button class="btn colorPrincipal text-white bold-botones mb-3 btn-cuadrado" type="submit" onClick={() => agregarOferta({ value: valueOferta, label: document.getElementById('nuevaOferta').value })}>{"Agregar oferta"}</button>
                                    </div>
                                </>
                            }
                        </div>
                        <BadgesUsadas badges={props.badgesOferta} funcion={eliminarOferta} />
                    </div>

                </div>
                <div className={props.filtro ? 'row mt-4' : 'row'}>

                    <div className={props.filtro ? 'mb-2' : 'col-md-3 offset-sm-1 col-sm-10 col-lg-2'}>
                        <label for="exampleInputEmail1" class="form-label letraDatos mb-2">
                            {props.filtro ? "Productos que usted ofrezca" : <div className='fw-bold'>Demanda (Insumos y/o servicios que necesite su empresa)</div>}
                        </label>

                    </div>


                    <div className={props.filtro ? 'col' : 'col-lg-8 col-md-7 col-sm-10 offset-sm-1 offset-md-0'}>
                        {/*<div class="input-group mb-3 mt-1">
                            <input type="text" id="demandaText" class="form-control letraDatos" placeholder="Producto/Servicio" 
                            aria-label="Producto/Servicio" aria-describedby="button-addon2"/>
                            <button class="btn btn-outline-primary btnProductos" type="button" id="button-addon2" onClick={agregarDemanda}>Agregar</button>
                            
                        </div>*/}
                        <div class="mb-3 mt-1">
                            {props.filtro ?
                                <SelectFiltrado agregarRubro={agregarDemanda} option={demandaEliminada} url={"empresa/distintosProductosDemandados"} placeholder={"Producto/Servicio"} reload={reloadCount} />
                                : <>
                                    {/*
                                <SelectCrear //selectedOption={selectedDemanda} setSelectedOption = {setSelectedDemanda}                        
                                    value={valueDemanda} setValue={setValueDemanda} agregarBadge={agregarDemanda} optionEliminada={demandaEliminada} />
                                    */}
                                    <label class="form-label letraDatos">Seleccione sus servicios o productos</label>
                                    <div class={"form-text textoErrores ms-1 d-inline"}>(Opcional)</div>

                                    <SelectFiltrado agregarRubro={agregarDemanda} option={demandaEliminada} url={"empresa/todosLosProductos"} placeholder={"Producto/Servicio"} />

                                    <FormInput id={"nuevaDemanda"} text={"Registre nuevos servicios o productos"} type={"text"} className={"col-12"} helper={"(Opcional)"}  placeholder={"Ej.: Laptop, Fotografía, Peluquería, Marketing"}/>
                                    <div className='text-center'>
                                        <button class="btn colorPrincipal text-white bold-botones mb-3 btn-cuadrado" type="submit" onClick={() => agregarDemanda({ value: valueDemanda, label: document.getElementById('nuevaDemanda').value })}>{"Agregar demanda"}</button>
                                    </div>
                                </>
                            }
                        </div>
                        <BadgesUsadas badges={props.badgesDemanda} funcion={eliminarDemanda} />
                    </div>

                </div>
            </div>
        </>
    );
}


export default OfertaDemanda;